import React from "react";
import { REPORTS_BASE_URL } from "../../props";
import { ToDoContext } from "./todo-context";
import { hasAnyRole } from "../../auth/authUtils";
import { useSelector } from "react-redux";
import {
  faCircleRight,
  faClock,
  faCirclePlus,
  faCircleUp,
  faQuestionCircle,
} from "@fortawesome/pro-solid-svg-icons";
import { useMediaQuery } from "@material-ui/core";

import Grid from "@material-ui/core/Grid";
import CspProjectSubmissionCard from "../../components/dashboard/CspProjectSubmissionCard";
import MediaPieChartCard from "./MediaPieChartCard";
import PendingItemsCard from "./PendingItemsCard";
import ToDoCard from "../../components/dashboard/TodoCard";
import UnorganizedItemsCard from "./UnorganizedItemsCard";
import ContentGroupsCard from "./ContentGroupsCard";

const managerTodos = [
  {
    id: 1,
    label: "Upload Media",
    path: "upload",
    search: "",
    icon: faCircleUp,
  },
  {
    id: 2,
    label: "Review Pending Files",
    path: "organize",
    search: "?view=review,pending",
    icon: faClock,
  },
  {
    id: 3,
    label: "Create A New Collection",
    path: "organize",
    search: "?view=organize,organize-ungrouped",
    icon: faCirclePlus,
  },
  {
    id: 4,
    label: "Organize My Content",
    path: "organize",
    search: "?view=organize",
    icon: faCircleRight,
  },
  {
    id: 5,
    label: "Request Reports",
    url: REPORTS_BASE_URL,
    path: "",
    search: "",
    icon: faQuestionCircle,
  },
];

const userTodos = [
  {
    id: 1,
    label: "Upload Media",
    path: "upload",
    search: "",
    icon: faCircleUp,
  },
  {
    id: 2,
    label: "Create A New Collection",
    path: "organize",
    search: "?view=organize,organize-ungrouped",
    icon: faCirclePlus,
  },
  {
    id: 3,
    label: "Organize My Content",
    path: "organize",
    search: "?view=organize",
    icon: faCircleRight,
  },
  {
    id: 4,
    label: "Request Reports",
    url: REPORTS_BASE_URL,
    path: "",
    search: "",
    icon: faQuestionCircle,
  },
];

const chooseTodoList = isManager => {
  if (isManager) {
    return managerTodos;
  } else {
    return userTodos;
  }
};

const CreatorUserDashboard = () => {
  const auth = useSelector(state => state.auth);
  const isManager = hasAnyRole(auth.currentOrganization, [
    "ROLE_CREATOR_MANAGER",
    "ROLE_CONTENT_MANAGER",
  ]);

  const isCreatorAdminDashboardMd = useMediaQuery(theme =>
    theme.breakpoints.up("creatorAdminDashboardMd"),
  );

  return (
    <ToDoContext.Provider
      value={{
        todos: chooseTodoList(auth),
        isManager,
      }}
    >
      <Grid container spacing={5}>
        <Grid item sm={12} md={8}>
          <Grid container spacing={5}>
            <Grid item sm={5}>
              <ToDoCard />
            </Grid>

            <Grid item sm={7}>
              <MediaPieChartCard />
            </Grid>

            <Grid item sm={12}>
              <ContentGroupsCard limit={isCreatorAdminDashboardMd ? 6 : 5} />
            </Grid>
          </Grid>
        </Grid>

        <Grid item sm={12} md={4}>
          <Grid container spacing={5}>
            <Grid item xs={4} md={12}>
              <Grid container spacing={5}>
                <Grid item sm={6}>
                  <PendingItemsCard />
                </Grid>

                <Grid item sm={6}>
                  <UnorganizedItemsCard />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={8} md={12}>
              <CspProjectSubmissionCard />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </ToDoContext.Provider>
  );
};

export default CreatorUserDashboard;
